/** @format */

import React from "react";

import { Button } from "../ui/button";
import {
  Download,
  Maximize2,
  Minimize2,
  RotateCw,
  ZoomIn,
  ZoomOut,
} from "lucide-react";

interface PdfControlsProps {
  numPages: number | null;
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onRotate: () => void;
  onDownload?: () => void;
  onFullscreenToggle?: () => void;
  isFullscreen?: boolean;
}

const PdfControls: React.FC<PdfControlsProps> = ({
  numPages,
  scale,
  onZoomIn,
  onZoomOut,
  onRotate,
  onDownload,
  onFullscreenToggle,
  isFullscreen = false,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2 p-3 pt-4 md:pt-3 bg-slate-800/60 border-b border-slate-600/50">
      <div className="hidden md:flex items-center gap-2">
        <span className="text-sm text-slate-300">
          {numPages ? `${numPages} pages` : "Loading..."}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-2 ml-auto w-full justify-end sm:w-auto">
        <Button onClick={onZoomOut}>
          <ZoomOut className="h-4 w-4" />
        </Button>
        <span className="text-sm text-slate-300">
          {Math.round(scale * 100)}%
        </span>
        <Button onClick={onZoomIn}>
          <ZoomIn className="h-4 w-4" />
        </Button>
        <Button onClick={onRotate}>
          <RotateCw className="h-4 w-4" />
        </Button>
        {onFullscreenToggle && (
          <Button
            onClick={onFullscreenToggle}
            aria-label={isFullscreen ? "Sair da tela cheia" : "Tela cheia"}
            title={isFullscreen ? "Sair da tela cheia" : "Tela cheia"}
          >
            {isFullscreen ? (
              <Minimize2 className="h-4 w-4" />
            ) : (
              <Maximize2 className="h-4 w-4" />
            )}
          </Button>
        )}
        {onDownload && (
          <Button onClick={onDownload}>
            <Download className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};

export { PdfControls };
